import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from 'react-router-class-tools';
import { styled, Global } from "../stitches.config";
import { h2, p, h1 } from '../redesign/commonStyles/Fonts';

import { withThemeContext } from "../redesign/components/StitchesThemeProvider";
import Content from "../components/Article/Content";
import CopyButton from '../redesign/components/CopyButton';

const Contacts = React.lazy(() => import(/* webpackChunkName: "components__Faq" */"../redesign/components/Career/Contacts"));;
const Faq = React.lazy(() => import(/* webpackChunkName: "components__Faq" */"../redesign/components/Career/Faq"));
const JobOfferTitle = React.lazy(() => import(/* webpackChunkName: "components__JobOffer" */"../redesign/JobOfferTitle"));
const Benefits = React.lazy(() => import(/* webpackChunkName: "components__Benefits" */"../redesign/components/Career/Benefits"))

@inject("ArticleStore", "CategoryStore", "UIStore")
@observer
class Article extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { ArticleStore, isDarkMode } = this.props;
    const isDesktop = window.innerWidth >= 996;

    return (
      <Fragment key="article-content-container">
        <Global
          styles={{
            ".app-content":
            {
              paddingTop: "1px",
              backgroundColor: "rgb(19, 18, 18)"
            }
          }}
        />

        <JobOfferTitle title={ArticleStore.article.title} tags={ArticleStore.article.offerTags} />

        <ArticleWrapper isDarkMode={isDarkMode}>
          <div className="container">
            <ArticleRow className="row">
              <ArticleColumn className="col-lg-8 column-left">
                <Content article={ArticleStore.article} hideAdslots />
              </ArticleColumn>
            </ArticleRow>
          </div>
          {/* #6033 - Kacper Mrochen */}
          {ArticleStore.article.offerConfig.length > 0 &&
            <OfferPageBenefits>
              <Header>
                <h2 className={h2()}>Co oferujemy?</h2>
                <p className={p()}>Praca w mediach to wielka odpowiedzialność. Każdego miesiąca czytają nas miliony Polaków, dlatego ważne jest, by pracować w przyjemnym i komfortowym środowisku.</p>
              </Header>
              <Benefits content={ArticleStore.article.offerConfig} isDesktop={isDesktop} />
            </OfferPageBenefits>
          }
          {/* dolna treść */}
          <Faq header='Więcej o pracy dla naTemat' />
          <Contacts isDesktop={isDesktop}>
            <ContactInfo id="job-offer-article__apply">
              <h2 className={h2()}>Dołącz do nas!</h2>
              <p className={p()}>Jeśli umiesz się chwalić, zrób to - najpierw w CV, a potem pierwszym zrealizowanym dla naTemat materiałem. Czekamy, aż napiszesz.</p>
              <p className={p()}>Przed wysłaniem do nas swojego CV prosimy o zapoznanie się z informacjami dotyczącymi przetwarzania danych osobowych - <a href='https://m.natemat.pl/files/17/b7/17b77b65e891fed32e7cefeb1bc53ba7.docx' target='blank'><OrangeSpan>TUTAJ </OrangeSpan></a>
                i <a href='https://m.natemat.pl/files/c6/2b/c62bfec876c4071751d894f2c4980644.docx' target='_blank'><OrangeSpan>TUTAJ</OrangeSpan></a>.</p>
              <div>
                <p className='grayparagraph'>Wyślij nam swoje CV:</p>
                <CopyButton text='praca@natemat.pl' primary={true} />
              </div>
            </ContactInfo>
          </Contacts>

        </ArticleWrapper>
      </Fragment>
    );
  }
}

const ContactInfo = styled('div', {
  padding: '16px',
  '@bp4': {
    width: '500px',
    div: {
      p: {
        color: '$grayscale50'
      },
    },
    p: {
      button: {
        '.svg-copy-icon': {
          fill: '#FFFFFF',
        },
      }
    },
    'a:hover': {
      textDecoration: 'none',
    }
  }
})

const OrangeSpan = styled('span', {
  color: '$natematPrimary',
})

export default withRouter(withThemeContext(Article));

export const ArticleWrapper = styled('article', {
  position: "relative",
  backgroundColor: "$grayscale10",
  paddingTop: "128px",
  "& .container": {
    overflowY: "clip",
  },
})

export const ArticleRow = styled('div', {
  display: "flex",
})

export const ArticleColumn = styled('div', {
  margin: "0 auto",
  width: "100%",
  maxWidth: "840px",
})

const Header = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '0px 16px 0px 16px',
  'h2': {
    margin: 0,
  },
  'p': {
    margin: "0 0 24px 0",
    '@bp4': {
      margin: "0 0 64px 0",
    }
  },
  '@bp4': {
    width: '900px',
    gap: '24px',
  }
})

const OfferPageBenefits = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  background: '$grayscale100Fixed',
  color: '$grayscale0Fixed',
  padding: '40px 30px 60px 30px',
  marginTop: "62px",
  '.benefits-slider': {
    '.slick-slider': {
      '.slick-list': {
        overflow: 'visible',
        '.slick-track': {
          display: 'flex',
          gap: '8px',
          '.slick-slide': {
            height: 'auto',
            'div': {
              color: '$grayscale100Fixed',
              background: '$grayscale0Fixed',
              height: '100%',
            },
            '&[aria-hidden="true"]': {
              opacity: 0.5,
            },
          },
        },
      },
      '.slick-dots': {
        bottom: '0px',
      },
      'ul': {
        transform: 'translateY(38px)',
        'li': {
          background: '$grayscale50',
          borderRadius: '50%',
          width: '10px',
          height: '10px',
          opacity: 0.1,
          '&.slick-active': {
            background: '$natematPrimary',
            opacity: 1,
            'button': {
              '&:before': {
                content: ''
              },
            },
          },
        },
      },
      '.slick-arrow': {
        display: 'none',
      },
    },
  },
  '.benefits-grid': {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '24px',
    '&>div': {
      background: '$grayscale0Fixed',
      color: '$grayscale100Fixed',
      flexBasis: '400px',
    }
  },
  '@bp4': {
    padding: '128px 84px 128px 84px',
    marginTop: "168px",
  }
})